import React from "react";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
//
import { RouterLoadingComponent } from "@components/router-loading-component";
//
import { isAxiosError } from "axios";
//
import { userInfoQueryOpts } from "src/services/apiQueries/userQueries";
import { queryClient } from "@config/tanstack/tanstackQuery";

// NOTE: /_authenticated isn't actually part of the URL, but instead
export const Route = createFileRoute("/_authenticated")({
  component: () => {
    return <Outlet />;
  },
  pendingComponent: RouterLoadingComponent,
  loader: async () => {
    const userInfo = await queryClient.ensureQueryData({
      ...userInfoQueryOpts(),
      staleTime: 5000,
    });
    return {
      userInfo,
    };
  },
  beforeLoad: async () => {
    try {
      await queryClient.ensureQueryData({
        ...userInfoQueryOpts(),
        staleTime: 5000,
      });
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 401) {
        throw redirect({ to: "/login", search: { next: location.pathname } });
      }
    }
  },
});
